// The production domain this landing will live on. Update here only.
export const PRODUCTION_SITE_URL = "https://landing.motorproautos.com";

// Never hardcode a canonical while running on a temporary preview/dev URL.
export const getSiteUrl = (): string => {
  if (typeof window !== "undefined" && window.location.origin) {
    const origin = window.location.origin;
    const isTemporaryHost =
      origin.includes("localhost") ||
      origin.includes("preview.emergentagent.com") ||
      origin.includes("127.0.0.1");
    return isTemporaryHost ? origin : PRODUCTION_SITE_URL;
  }
  return PRODUCTION_SITE_URL;
};
